import React from "react";
import WorkflowIcon from "../components/icons/workflow";
import { Link, useNavigate } from "react-router-dom";
import SettingIcon from "../components/icons/setting";
import ContactIcon from "../components/icons/contact";
import userPool from "../aws-exports";

function BaseLayoutV2({ children }) {
  const cognitoUser = userPool.getCurrentUser();
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 h-screen bg-[#EDEFF4] w-screen">
      {/* Left sidebar */}
      <div className="col-span-2 h-screen sticky top-0 bg-[#000000] overflow-y-auto flex flex-col items-center">
        <Link
          to={"/"}
          className="flex items-center w-full justify-center border-b-[#FFFFFF1F] border-b p-[25px]"
        >
          <img src="/logo.png" alt="" />
        </Link>
        <div className="flex flex-col gap-3 items-center w-full justify-center border-b-[#FFFFFF1F] border-b p-[25px]">
          <Link
            to={"/workflow"}
            className="w-full cursor-pointer bg-[#85C9EA] flex items-center gap-[10px] rounded-[5px] p-[10px]"
          >
            <WorkflowIcon />
            <p className="text-[14px] font-[600]">Workflow Analysis</p>
          </Link>
          <Link
            to={"/v2/workflow"}
            className="w-full cursor-pointer bg-[#85C9EA] flex items-center gap-[10px] rounded-[5px] p-[10px] relative"
          >
            <WorkflowIcon />
            <p className="text-[14px] font-[600]">
              Workflow Analysis (V2){" "}
              <span className="absolute -top-1 -right- text-xs bg-red-400 text-white px-2 py-1 rounded-full">
                New
              </span>
            </p>
          </Link>
          <Link
            to={"/tools"}
            className="w-full cursor-pointer bg-[#85C9EA] flex items-center gap-[10px] rounded-[5px] p-[10px]"
          >
            <SettingIcon />
            <p className="text-[14px] font-[600]">All Tools</p>
          </Link>
          <Link
            to={"/contact"}
            className="w-full cursor-pointer bg-[#85C9EA] flex items-center gap-[10px] rounded-[5px] p-[10px]"
          >
            <ContactIcon />
            <p className="text-[14px] font-[600]">Contact</p>
          </Link>
          {cognitoUser && (
            <>
              <div
                className="w-full cursor-pointer bg-[#85C9EA] flex items-center gap-[10px] rounded-[5px] p-[10px]"
                onClick={() =>
                  cognitoUser.signOut(() => {
                    navigate("/sign_in");
                  })
                }
              >
                <SettingIcon />
                <p className="text-[14px] font-[600]">Sign Out</p>
              </div>
            </>
          )}
        </div>
      </div>
      {/* Main body */}
      <main className="col-span-10 h-screen flex flex-col items-center w-full">
        {/* <header className="sticky top-0 bg-white w-full p-4 shadow-md z-10">
          <h1>King Genomics</h1>
        </header> */}
        <div className="h-full w-full overflow-y-auto">{children}</div>
      </main>
    </div>
  );
}

export default BaseLayoutV2;
